/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import Cookies from 'cookies-js'
import get from 'lodash/get'
import classNames from 'classnames'
import {
  RetailItinerary,
  RetailItineraryNew,
  SliceDetails,
  ExpressDealCard,
  AncillaryLegend,
  DepartureSummaryCarousel,
} from '@pcln/fly-ui-components'
import ClosedUserGroupNotification from '@pcln/air-closed-user-group-deals-notification'
import { Box, Flex, SrOnly, Button, Text } from 'pcln-design-system'
import moment from 'moment'
import styled, { css } from 'styled-components'
import MobileSliceCtaButton from '../MobileSliceCta'
import Itinerary from '../Itinerary/'
import { SliceMerchandisingStamp } from '../SBS/SliceMerchandisingStamp/SliceMerchandisingStamp'
import ItineraryShelf from '../Itinerary/ItineraryShelf'
import SponsoredCarrier from '../SponsoredCarrier'
import { wrapComponentsRenderInView } from '../../util/wrapComponentsRenderInView'
import { getPriceGuidanceNode } from '../../util/getPriceGuidanceNode'
import {
  getSBSItineraryData,
  goToDetailsClick,
  returnToDepartureTab,
  getNextSliceClick,
  getEnabledMerchandisingData,
  getCombinedMerchandisings,
} from '../../util/SBSHelpers/SBSHelpers'
import FareBrandShelfHeader from '../FareBrandShelf/FareBrandShelfHeader'
import { isAffirmEligible, AffirmWrapper } from '../Affirm/AffirmWrapper'
import { buildNumOfItinsReturnedText } from '../../util/buildScreenReaderText/buildScreenReaderText'
import { AdsRenderModal } from '../../util/Ads/AdsRenderModal'
import { getExdProps } from './helpers/expressDealHelpers'
import { ListingsHeader } from '../ListingsHeader/ListingsHeader'
import { PriceDisclosure } from '../PriceDisclosure/PriceDisclosure'
import { PRICE_DISCLOSURE_TEXT } from '../PriceDisclosure/constants'
import { ListingFilterChips } from './ListingFilterChips'

const ItineraryList = styled.ul`
  padding-left: 0 !important;
`

const StyledRetailItinerary = styled(RetailItinerary)`
  margin: 0 8px 0 8px;

  ${(props) => props.theme.mediaQueries.xl} {
    margin: 0;
  }
`

const StyledRetailItineraryNew = styled(RetailItineraryNew)`
  margin: 0 8px 0 8px;

  ${(props) => props.theme.mediaQueries.xl} {
    margin: 0;
  }
`

const BackToResults = styled(Button)`
  font-size: 12px;
  font-weight: bold;
`

const DepartureSummaryWrapper = styled(Box)`
  ${(props) =>
    props.isSticky &&
    css`
      z-index: 999;
      position: sticky;
      top: ${props.departureSummaryCardStickyTop};
    `}

  ${({ theme }) => theme.mediaQueries.lg} {
    ${({ isSticky }) =>
      isSticky &&
      css`
        z-index: 0;
        position: static;
        top: 0;
        background-color: transparent;
      `}
  }
`

const MobileCugBanner = styled(Box)`
  margin-bottom: 10px;
  font-weight: 500;

  ${(props) => props.theme.flyQueries.tablet} {
    display: none;
  }
`

const MemoizedRetailItinerary = React.memo(StyledRetailItinerary)
const MemoizedRetailItineraryNew = React.memo(StyledRetailItineraryNew)
const MemoizedExpressDealCard = React.memo(ExpressDealCard)

function setNoTooltipCookie() {
  const cookieOpts = {
    path: '/m/fly/search',
    // 30 days from now
    expires: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000),
  }

  Cookies.set('NO_SLICE_HOVER_TOOLTIP', 'true', cookieOpts)
}

function getNoTooltipCookie() {
  return !!Cookies.get('NO_SLICE_HOVER_TOOLTIP')
}

class Listings extends React.PureComponent {
  constructor(props) {
    super(props)
    const desktopWidth = 1024
    const ipadWidth = 768
    const SETI = props.SETI

    this.state = {
      SETI,
      hasNoHoverTooltipCookie: getNoTooltipCookie() || false,
      isCouponActivated: false,
      isCouponLoading: false,
    }

    this.adsRendered = new AdsRenderModal()

    // needs refactoring:
    // just normalize the data on this.props.listings or force the parents to supply IDs
    this.adCount = 0
    this.retailCount = 1
    this.departureSummaryData = null
    this.setNoTooltipOnHoverCookie = this.setNoTooltipOnHoverCookie.bind(this)
    this.deviceWidth = props.initialDeviceWidth
    this.onExdSelect = this.onExdSelect.bind(this)
    this.onExdClick = this.onExdClick.bind(this)
    const isShelfEligible = this.props.isShelfEligible
    this.shelfVariantName = get(SETI, 'AIR_SEARCH_BRANDED_SHELF_NGS_OW2.variantName', 'DEFAULT')
    this.showAirportToolTip = get(SETI, 'AIR_SEARCH_LISTINGS_AIRPORT_TOOLTIPS.isVariant', false)
    this.ctaSliceButton = get(SETI, 'AIR_SEARCH_SLICE_FILTER_MOBILE_CTA.isVariant', false)
    this.sliceFiltersMobile = get(SETI, 'AIR_SEARCH_SLICE_FILTERS_MOBILE.isVariant', false)
    this.isDesktop = Boolean(this.deviceWidth >= desktopWidth)
    this.isMobile = Boolean(this.deviceWidth < ipadWidth)
    this.isShelfItinerary = isShelfEligible && ['TWOSHELVES', 'THREESHELVES'].includes(this.shelfVariantName)
    this.sbsTestIdPrefix = SETI?.AIR_LISTINGS_CARD_REFACTOR_DESKTOP?.isVariant
      ? 'retail-new-sliceId'
      : 'retail-sliceId'
    this.getSBSData = getSBSItineraryData
    this.SBSRetailComponent = SETI?.AIR_LISTINGS_CARD_REFACTOR_DESKTOP?.isVariant
      ? MemoizedRetailItineraryNew
      : MemoizedRetailItinerary

    if (isShelfEligible) {
      this.props.flyGaLogic.fire.addSetiDimension(
        'dimension135',
        'AIR_SEARCH_BRANDED_SHELF_NGS_OW2',
        get(SETI, 'AIR_SEARCH_BRANDED_SHELF_NGS_OW2.variantName', 'DEFAULT')
      )
      this.props.pclnExpt.fireImpression('AIR_SEARCH_BRANDED_SHELF_NGS_OW2')
    }

    this.listingsContainerRef = React.createRef()

    this.stickyDepartureSummaryCard = this.props.hasUSDestinationsOnly
  }

  componentDidUpdate(prevProps) {
    const isRT = this.props.tripType === 'RT'
    if (isRT && this.props.activeTabId !== prevProps.activeTabId) {
      this.adsRendered = new AdsRenderModal()
    }
  }

  /* istanbul ignore next */
  renderMobileAds = (adId) => {
    if (window && window.PCLN && !this.adsRendered[adId] && document.getElementById(adId)) {
      this.adsRendered[adId] = true
      window?.PCLN?.pclnEventDispatcher?.dispatch('AIR_MOBILE_ADS', [adId])
    }
  }

  getChildContext() {
    const {
      flyGaLogic,
      pclnExpt,
      onSliceFilter,
      anySlicesFilteredFor,
      onListingItemSelect,
      onExdItemSelect,
      CTAText,
      CTAButtonTextExd,
      pricingDisclosure,
      product,
      excludeSliceFiltering,
      searchKey,
      alwaysRenderFirstN,
    } = this.props
    // NB: There's SETI (raw) from props
    // and SETI (normalized) from state
    const { SETI } = this.state

    return {
      SETI,
      // used by ExpressDeal and probably a few more places TK
      flyGaLogic,
      pclnExpt,
      // this context will be wormholed down to <MobileCheckbox />
      anySlicesFilteredFor,
      onSliceFilter,
      // used by PKG, since they don't redirect to fly-deals
      onExdItemSelect,
      // do this once since Long Layovers needs it
      onSelect: onListingItemSelect,
      // override the text of the CTA in the pricebox
      // (including express deals if CTAButtonTextExd is unspecified)
      CTAText,
      // override the text of the CTA in the pricebox for express deals only
      CTAButtonTextExd,
      // additional disclosure to be placed near the pricing information
      pricingDisclosure,
      // prevent conflicts between AIR and PKG specific features in common UI elements e.g. pricebox
      isAir: product === 'AIR',
      isPkg: product === 'PKG',
      excludeSliceFiltering,
      searchKey,
      isShelfItinerary: this.isShelfItinerary,
      alwaysRenderFirstN,
    }
  }

  componentDidMount() {
    if (this.props.onListingsMount) {
      const listingsLoadTimerEnd = new Date()
      this.props.onListingsMount(listingsLoadTimerEnd)
    }

    // What is this?
    if (!this.props.deeplinkModelToken && this.props.showLoadingScreenServerSide) {
      this.props.showLoadingScreenServerSide(false)
    }

    this.props.pclnExpt.fireImpression('AIR_LISTINGS_FILTER_RETAIN')

    if (!this.props.isReshopExperience && !(this.props.tripType === 'MD' && !this.props.isFireFly)) {
      this.props.pclnExpt.fireImpression('AIR_LISTINGS_ANCILLARIES_ON_CARDS')
    }

    if (this.isDesktop) {
      this.props.pclnExpt.fireImpression('AIR_LISTINGS_CARD_REFACTOR_DESKTOP')
    }

    this.props.listingsDidMountCallbacks.forEach((callback) => callback())
  }

  onExdClick(e) {
    if (e.key === 'Enter' || e.keyCode === 13 || e.key === ' ' || e.keyCode === 32 || e.type === 'click') {
      e.preventDefault()
      const exdIndex = this.props.listings.findIndex((itin) => itin.isExpressDeal)
      this.onExdSelect(this.props.searchKey, this.props.listings[exdIndex], exdIndex + 1, e)
    }
  }

  getAdCount() {
    return this.adCount++
  }

  getRetailCount() {
    return this.retailCount++
  }

  setNoTooltipOnHoverCookie() {
    setNoTooltipCookie()
    this.setState({ hasNoHoverTooltipCookie: true })
  }

  onExdSelect(searchKey, itinerary, position) {
    const { priceBreakersProps, pclnExpt } = this.props

    if (priceBreakersProps?.priceBreakersSessionKey && pclnExpt?.fireImpression) {
      pclnExpt.fireImpression('AIR_SEARCH_PRICEBREAKERS_MVP')
    }

    if (
      this.state?.SETI?.AIR_SEARCH_PRICEBREAKERS_MVP?.isVariant &&
      priceBreakersProps?.priceBreakersSessionKey
    ) {
      const { handlePriceBreakers } = priceBreakersProps
      handlePriceBreakers()
      return
    }

    const queryString = window.location.search
    let path = window.location.pathname
    // Ensure path ends with '/' for proper routing to /deals
    path = path.endsWith('/') ? path : `${path}/`

    let queries = queryString ? `${queryString}&search-key=${searchKey}` : `?search-key=${searchKey}`
    const regEx = /priceline/

    if (itinerary.isFlexDatesExd) {
      queries = queryString
      const departString = `${itinerary.origin1}-${itinerary.destination1}-${moment(
        itinerary.departDate
      ).format('YYYYMMDD')}/`

      if (itinerary.tripType === 'RT') {
        const returnString = `${itinerary.origin2}-${itinerary.destination2}-${moment(
          itinerary.returnDate
        ).format('YYYYMMDD')}/`

        path = `/m/fly/search/${departString}${returnString}`
      } else {
        path = `/m/fly/search/${departString}`
      }
    }

    // Add `isFireFly` flag for FireFly EXD
    if (itinerary.priceKey && itinerary.itemKey) {
      queries = `${queries}&priceKey=${itinerary.priceKey}&itemKey=${itinerary.itemKey}`
    }

    // example: m/fly/search/NYC-SFO-20201213/SFO-NYC-20201216/deals
    const redirectPath = `${path}deals`

    this.props.flyGaLogic.fire.sopqAction(position, 'click')

    // AIR-22631
    if (itinerary.listingPosition > 30) {
      this.props.flyGaLogic.fire.EXDListingsPositionClicked('30+')
    } else {
      this.props.flyGaLogic.fire.EXDListingsPositionClicked(itinerary.listingPosition)
    }

    if (location.host && !regEx.test(location.host)) {
      this.props.flyGaLogic.fire.sopqUrl(`${location.host}${redirectPath}${queries}`, 'Exp Deal Url')
    }

    if (queries) {
      window.open(`${redirectPath}${queries}&new-tab=true`, '_blank')
    } else {
      window.open(`${redirectPath}?new-tab=true`, '_blank')
    }
  }

  openLoginModal = (e) => {
    if (e) {
      e.stopPropagation()
    }
    if (window.PCLN) {
      window.PCLN.pclnEventDispatcher.dispatch('GLOBAL_PCLN_LAUNCH_SIGNIN_MODAL')
      this.props.flyGaLogic.fire.cugEligible('CUG_Signed_In_Listing')
    }
  }

  showCTASliceButton = () => {
    let showButton = this.ctaSliceButton
    let singleItinerary = false
    if (
      this.props.hasExpressDeal ||
      (this.props.listings && this.props.listings.length > 0 && this.props.listings[0].isExpressDeal)
    ) {
      singleItinerary = this.props.listings.length < 3
    } else {
      singleItinerary = this.props.listings.length === 1
    }
    if (singleItinerary && this.isMobile) {
      this.props.pclnExpt.fireImpression('AIR_SEARCH_SLICE_FILTER_MOBILE_CTA')
    }
    return showButton && singleItinerary
  }

  listItems = () => {
    const { hasNoHoverTooltipCookie } = this.state
    const {
      activeTabId,
      departingFrom,
      returningFrom,
      listings,
      searchKey,
      exdCarriers,
      disableAds,
      sponsoredCarrier,
      minimumRetailPrice,
      flyGaLogic,
      searchReferralId,
      listingIsLoading,
      userLoggedIn,
      listingsSaleStyle,
      airportToCity,
      nonStopPrice,
      onListingItemSelect,
      outBoundFlight,
      isRTSliceBySlice,
      hasUSDestinationsOnly,
      handleDepartureSliceClick,
      isCachedListings,
      tripType,
      isSBS,
      isSBSQL,
      brandReference,
      pclnExpt,
      pclnGptDartAds,
      searchRequestCabinClass,
      hasExpressDeal,
      xSellAd,
      priceGuidanceData,
      priceBreakersProps,
      adsContainer,
      cancellationText,
      cancelTextColor,
      cancelFooterIcon,
      covidDisplayAttributes,
      hasEuropeFlight,
      vipTier,
      isExpoToggleLD,
      isFireFly,
      enableExpressDealVip,
      numSlices,
      isReshopExperience,
      reshopPerPersonText,
      isUpsellTray,
      fetchUpsellTrayOptions,
      isMultipleAirlinesLogoVariant,
      gaTagUpsellTileClick,
      errorLogUpsellCallListings,
    } = this.props

    const isShowAffirm = isAffirmEligible({
      minimumRetailPrice,
    })

    const couponClick = (e, cb) => {
      if (flyGaLogic) {
        flyGaLogic.fire.fireGenericListingsEvent(
          'SOPQ Discount button clicked by user',
          'SOPQ Discount button'
        )
      }
      e.stopPropagation()
      this.setState({
        isCouponLoading: true,
      })
      setTimeout(() => {
        this.setState({
          isCouponLoading: false,
          isCouponActivated: true,
        })
        if (cb) {
          cb()
        }
      }, 1000)
    }

    let retailPosition = 0
    let retailIndex = 0
    const sponsoredCarrierProp = sponsoredCarrier || {
      name: null,
      code: null,
      logoUrl: null,
      lowestFare: null,
    }

    if (listings?.[0]?.coupon && flyGaLogic) {
      flyGaLogic.fire.fireGenericListingsEvent('SOPQ Discount button shown to user', 'SOPQ Discount button')
    }

    this.retailCount = 1

    const sponsoredCarrierComponent = {
      hide: !sponsoredCarrierProp.name,
      component: (
        <SponsoredCarrier
          key='SponsoredCarrier'
          airline={sponsoredCarrierProp.name}
          imageSrc={sponsoredCarrierProp.logoUrl}
          fromPrice={sponsoredCarrierProp.lowestFare}
          showBanner={!!sponsoredCarrierProp.name}
          flyGaLogic={this.props.flyGaLogic}
          selectNoneSelector="fly-filters-airlines span[ng-click='noneAction()']"
          filterAirlineSelector={`fly-mobile-checkbox[checkbox-name='${sponsoredCarrierProp.code}']`}
        />
      ),
    }

    // SETI: AIR_CUG_LOCK_MOBILE
    const cugNotificationComponent = {
      hide: false,
      component: (
        <MobileCugBanner data-test='cug-eligible-mobile-banner'>
          <ClosedUserGroupNotification loggedIn={false} isStacked={false} savings={0} />
        </MobileCugBanner>
      ),
    }

    let firstCUGIndex = null
    const showCUGMobileBanner =
      get(this.state, 'SETI.AIR_CUG_LOCK_MOBILE.isVariant', false) && !this.isDesktop

    let listingsNodes = listings.map((itinerary, index) => {
      if (itinerary.crossSellAd && xSellAd) {
        return {
          hide: false,
          component: xSellAd,
        }
      }

      if (itinerary.ad && !disableAds) {
        // TODO: as part of the normalization process,
        // wouldn't it be best for the ads to already have their
        // proper ids ready instead of having to do an ad-hoc lookup
        const adId = get(pclnGptDartAds, `[${itinerary.adIndex}].gptDivId`)

        if (adId && adsContainer && this.deviceWidth < 840) {
          return {
            hide: false,
            inlineAds: true,
            adId,
            renderMobileAds: this.renderMobileAds,
            component: (
              <div>
                {React.cloneElement(adsContainer, {
                  adId,
                  key: adId,
                  gaIndex: this.getAdCount(),
                  departingFrom,
                  returningFrom,
                  searchReferralId,
                  inlineAds: true,
                })}
              </div>
            ),
          }
        }
      }

      if (!listingIsLoading && !disableAds && adsContainer && itinerary.isSponsoredAd && itinerary.adId) {
        return {
          hide: false,
          isSponsoredAd: true,
          component: (
            <div>
              {React.cloneElement(adsContainer, {
                adId: itinerary.adId,
                key: itinerary.adId,
                gaIndex: this.getAdCount(),
                departingFrom,
                returningFrom,
                searchReferralId,
                isSponsored: true,
              })}
            </div>
          ),
        }
      }

      if (itinerary.isCugEligible && firstCUGIndex === null) {
        firstCUGIndex = index
      }

      if (
        itinerary.isExpressDeal &&
        !(this.isShelfItinerary && itinerary.isFlexDatesExd) &&
        (!isSBS || (isSBS && activeTabId === 1))
      ) {
        const position = index + 1

        // TODO use generic functions
        this.props.flyGaLogic.fire.sopqAction(position, 'display')

        return {
          hide: this.props.hasExpressDeal && !listings[0]?.isExpressDeal,
          component: (
            <MemoizedExpressDealCard
              mx={[2, 2, 2, 2, 0]}
              {...getExdProps({
                searchRequest: this.props.searchRequest,
                onExdClick: this.onExdClick,
                openLoginModal: this.openLoginModal,
                itinerary,
                userLoggedIn,
                exdCarriers,
                vipTier,
                pclnExpt,
                isFireFly,
                enableExpressDealVip,
              })}
            />
          ),
        }
      }

      if (!itinerary.ad && !itinerary.nyop && !itinerary.isExpressDeal && !itinerary.crossSellAd) {
        if (retailPosition === 0) {
          retailPosition = index + 1
        }
        if (itinerary.itineraryLabel && itinerary.itineraryLabel.shortText === 'RECOMMENDED') {
          this.props.flyGaLogic.fire.popularFlights('Display')
        }

        let variantItineraryComponent = null
        let SBSData = null
        let sliceOnClick = null
        if (isSBS) {
          SBSData = this.getSBSData({
            itinerary,
            isDepartureSummary: false,
            isUserLoggedIn: userLoggedIn,
            activeTabId,
            departureSummaryData: this.departureSummaryData?.length
              ? this.departureSummaryData[this.departureSummaryData.length - 1]
              : null,
            tripType,
            isSBSQL,
            brandReference,
            pclnExpt,
            showOriginDate: this.props.showOriginDate,
          })
          if (isSBS && activeTabId < numSlices) {
            sliceOnClick = getNextSliceClick(itinerary, handleDepartureSliceClick)
          } else if (activeTabId === numSlices || tripType === 'OW') {
            sliceOnClick = goToDetailsClick(
              onListingItemSelect,
              itinerary.id,
              itinerary,
              this.getRetailCount()
            )
          }

          /**
           * --------------------------------- Badge logic start: ---------------------------------
           * Push appropriate badge to label array based on test
           * TODO: Remove CovidLabels entirely once test is over.
           */

          const combinedMerchandisings = getCombinedMerchandisings(itinerary)

          if (Array.isArray(combinedMerchandisings)) {
            const durationInMinutes = itinerary?.slices?.[0]?.durationInMinutes
            const minDurationInMinutes = this.props?.listingsMetaData?.minDurationInMinutes
            if (
              parseInt(durationInMinutes) === minDurationInMinutes &&
              !combinedMerchandisings.includes('SHORTEST_DURATION')
            ) {
              combinedMerchandisings.push('SHORTEST_DURATION')
            }
            if (combinedMerchandisings.includes('BEST_VALUE')) {
              combinedMerchandisings.splice(combinedMerchandisings.indexOf('BEST_VALUE'), 1)
            }
          }
          let merchandisingList = getEnabledMerchandisingData(combinedMerchandisings)
          merchandisingList = merchandisingList
            ?.map((merchandising) => {
              return (
                <Flex mr={1}>
                  <SliceMerchandisingStamp
                    icon={merchandising?.icon}
                    shortText={merchandising?.shortText}
                    color={merchandising?.color}
                  />
                </Flex>
              )
            })
            ?.slice(0, 3)

          // Display "no change fees" badge conditions (if changeable ticket included)
          const isNoChangeFee =
            itinerary?.allFareBrandAttributes[0]?.some(
              (farebrand) => farebrand.type === 'REBOOKING' && farebrand.inclusion === 'INCLUDED'
            ) && tripType !== 'MD'

          /* ---------------------------------- Badge logic end: ---------------------------------- */

          const SBSRetailComponent = this.SBSRetailComponent
          variantItineraryComponent = (
            <SBSRetailComponent
              {...SBSData}
              onClick={sliceOnClick}
              signInOnClick={this.openLoginModal}
              isMobile={this.isMobile}
              label={merchandisingList}
              itinerary={itinerary}
              showAirportToolTip={this.showAirportToolTip}
              onListingItemSelect={onListingItemSelect}
              testId={`${this.sbsTestIdPrefix}-${activeTabId}-index-${retailIndex++}`}
              isCancellable={
                isFireFly ? !!Number(itinerary.voidWindowInfo?.hoursLeft) : !!itinerary.voidWindowInfo
              }
              cancellationText={cancellationText}
              cancelTextColor={cancelTextColor}
              cancelFooterIcon={cancelFooterIcon}
              hasEuropeFlight={hasEuropeFlight}
              voidWindowInfo={itinerary?.voidWindowInfo}
              affirmNode={
                isShowAffirm && itinerary?.totalPriceWithDecimal?.price ? (
                  <AffirmWrapper price={itinerary?.totalPriceWithDecimal?.price} />
                ) : null
              }
              isExpoToggleLD={isExpoToggleLD}
              searchRequestCabinClass={searchRequestCabinClass}
              hideAncillaryLegend={
                pclnExpt.isVariant('AIR_LISTINGS_ANCILLARIES_ON_CARDS') &&
                !isReshopExperience &&
                !(tripType === 'MD' && !isFireFly)
              }
              isNoChangeFee={isNoChangeFee}
              isReshopExperience={isReshopExperience}
              reshopPerPersonText={reshopPerPersonText}
              pclnExpt={pclnExpt}
              isUpsellTray={isUpsellTray}
              gaTagUpsellTileClick={gaTagUpsellTileClick}
              errorLogUpsellCallListings={errorLogUpsellCallListings}
              fetchUpsellTrayOptions={fetchUpsellTrayOptions}
              isMultipleAirlinesLogoVariant={isMultipleAirlinesLogoVariant}
            />
          )
        } else if (this.isShelfItinerary) {
          variantItineraryComponent = (
            <ItineraryShelf
              listingIsLoading={listingIsLoading}
              gaIndex={this.getRetailCount()}
              hasNoHoverTooltipCookie={hasNoHoverTooltipCookie}
              itinerary={itinerary}
              key={index}
              position={index + 1}
              setNoTooltipOnHoverCookie={this.setNoTooltipOnHoverCookie}
              isUserLoggedIn={userLoggedIn}
              openLoginModal={this.openLoginModal}
              listingsSaleStyle={listingsSaleStyle}
              airportToCity={airportToCity}
              showCUGMobileLock={showCUGMobileBanner}
              outBoundFlight={outBoundFlight}
              isRTSliceBySlice={isRTSliceBySlice}
              brandReference={brandReference}
              slices={this.props.slices}
              searchRequestCabinClass={searchRequestCabinClass}
              departingFrom={departingFrom}
              shelfVariantName={this.shelfVariantName}
            />
          )
        }

        return {
          hide: false,
          component: variantItineraryComponent ? (
            variantItineraryComponent
          ) : (
            <Itinerary
              listingIsLoading={listingIsLoading}
              gaIndex={this.getRetailCount()}
              hasNoHoverTooltipCookie={hasNoHoverTooltipCookie}
              itinerary={itinerary}
              key={index}
              showAirportToolTip={this.showAirportToolTip}
              position={index + 1}
              setNoTooltipOnHoverCookie={this.setNoTooltipOnHoverCookie}
              isUserLoggedIn={userLoggedIn}
              openLoginModal={this.openLoginModal}
              listingsSaleStyle={listingsSaleStyle}
              airportToCity={airportToCity}
              showCUGMobileLock={showCUGMobileBanner}
              outBoundFlight={outBoundFlight}
              isRTSliceBySlice={isRTSliceBySlice}
              brandReference={brandReference}
              slices={this.props.slices}
              minimumRetailPrice={minimumRetailPrice}
              searchReturnedExpressDeals={hasExpressDeal}
              departingFrom={departingFrom}
              hideCtaButton={this.isDesktop}
              isCachedListings={isCachedListings}
              showNoChangesBadge={false}
              searchRequestCabinClass={searchRequestCabinClass}
            />
          ),
        }
      }

      return null
    })

    /*
    Sponsored carrier banner should always be listed between 2nd and 3rd retail listing.
    */
    listingsNodes.splice(retailPosition + 1, 0, sponsoredCarrierComponent)

    if (firstCUGIndex !== null && !this.isDesktop) {
      pclnExpt.fireImpression('AIR_CUG_LOCK_MOBILE')
    }

    // SETI: AIR_CUG_LOCK_MOBILE
    if (showCUGMobileBanner && !userLoggedIn && firstCUGIndex !== null) {
      listingsNodes.splice(firstCUGIndex + 1, 0, cugNotificationComponent)
    }

    const priceGuidanceNode = getPriceGuidanceNode({
      firstListing: listings.find((listing) => !listing.isExpressDeal),
      priceGuidanceData,
      minimumRetailPrice,
      pclnExpt,
    })

    if (priceGuidanceNode) {
      listingsNodes.splice(5, 0, priceGuidanceNode)
    }

    listingsNodes = listingsNodes.filter((elem) => !!elem)

    // Wrap each node in HOC to prevent rendering until element enters viewport
    if (this.props.useRenderInView) {
      listingsNodes = wrapComponentsRenderInView(listingsNodes, this.props.alwaysRenderFirstN)
    } else {
      listingsNodes = listingsNodes.map((node) => node && node.component)
    }

    return listingsNodes
  }

  render() {
    const {
      activeTabId,
      listings,
      listingsMetaData: { totalFilteredItineraries },
      disableTaxesAndFeesDisclosure,
      flyGaLogic,
      handleTabChange,
      isSBS,
      selectedDepartureSummaries = [],
      tripType,
      pclnExpt,
      showOriginDate,
      showFilterChips,
      numSlices,
      isMultiDestination,
      searchSlices,
      isFireFly,
      isReshopExperience,
      showBaggageFeeLink,
      showLoadingOverlay,
    } = this.props

    const hideAncillaryLegend =
      pclnExpt.isVariant('AIR_LISTINGS_ANCILLARIES_ON_CARDS') &&
      !(tripType === 'MD' && !isFireFly) &&
      !isReshopExperience

    // Focus page to listings container
    this.listingsContainerRef.current?.focus()
    const listingsContainerCss = classNames('fly-search-listings-container', 'white-background')
    const listingsUtilityBar = classNames('fly-search-listings-container--utility-bar', 'no-padding')
    const listingsFullWidth = classNames('fly-search-listings full-width', 'no-padding')

    if (activeTabId > 1) {
      this.departureSummaryData = selectedDepartureSummaries.map((selectedDepartureSummary) =>
        this.getSBSData({
          itinerary: selectedDepartureSummary,
          isDepartureSummary: true,
          isUserLoggedIn: null,
          activeTabId: activeTabId,
          departureSummaryData: null,
          tripType: null,
          isSBSQL: null,
          brandReference: null,
          pclnExpt,
        })
      )
    }
    const departingText = `Showing ${this.props.listingsMetaData.totalFilteredItineraries}
    flights to ${this.props.returningFrom.cityName}, ${this.props.returningFrom.cityCode} (${this.props.returningFrom.airportCode})`

    return (
      <section className={listingsContainerCss}>
        {!this.isShelfItinerary && !disableTaxesAndFeesDisclosure && !isSBS && (
          <div className={listingsUtilityBar}>
            <ListingsHeader tripType={tripType} />
            <PriceDisclosure showBaggageFeeLink={showBaggageFeeLink} />
            {!hideAncillaryLegend && <AncillaryLegend showDesktop={this.isDesktop} />}
          </div>
        )}

        <SrOnly ref={this.listingsContainerRef} tabIndex={0}>
          {buildNumOfItinsReturnedText(totalFilteredItineraries, listings, activeTabId < numSlices)}
        </SrOnly>

        {this.isShelfItinerary && (
          <FareBrandShelfHeader
            priceDisclosure={PRICE_DISCLOSURE_TEXT}
            shelfVariantName={this.shelfVariantName}
          />
        )}

        {isSBS && (
          <React.Fragment>
            {activeTabId > 1 && (
              <React.Fragment>
                <DepartureSummaryWrapper
                  bg='background.lightest'
                  mb={3}
                  mx={this.departureSummaryData?.length > 1 ? [1, 1, 1, 4, 0] : [2, 2, 2, 2, 0]}
                  isSticky={this.stickyDepartureSummaryCard}
                  departureSummaryCardStickyTop={this.props.departureSummaryCardStickyTop}
                >
                  <DepartureSummaryCarousel
                    currentSlide={showLoadingOverlay ? 0 : this.departureSummaryData.length - 1}
                    isMultiDestination={isMultiDestination}
                    searchSlices={searchSlices}
                    selectedSlices={this.departureSummaryData.map((summary, index) => ({
                      ...summary,
                      isSticky: this.stickyDepartureSummaryCard,
                      changeFlightHandler: returnToDepartureTab(
                        handleTabChange,
                        flyGaLogic,
                        'Change Flight',
                        index
                      ),
                      sliceDetailsNode: (
                        <SliceDetails {...summary} isDepartureSummary showOriginDate={showOriginDate} />
                      ),
                    }))}
                    onSlideChange={this.props.logCarouselArrow}
                  />
                </DepartureSummaryWrapper>
              </React.Fragment>
            )}
            <ListingsHeader
              tripType={tripType}
              activeTabId={activeTabId}
              isSBS={isSBS}
              searchSlices={searchSlices}
            />
            {this.isDesktop && !hideAncillaryLegend ? <AncillaryLegend showDesktop={this.isDesktop} /> : null}
            <PriceDisclosure showBaggageFeeLink={showBaggageFeeLink} />
            {!this.isDesktop && !hideAncillaryLegend ? <AncillaryLegend showDesktop={false} /> : null}
          </React.Fragment>
        )}
        {showFilterChips && this.props.filtersLists?.length > 0 ? (
          <Box>
            <ListingFilterChips
              filtersLists={this.props.filtersLists}
              clearFilters={this.props.clearFilters}
            />
          </Box>
        ) : null}
        <ItineraryList className={listingsFullWidth}>{this.listItems()}</ItineraryList>
        {this.showCTASliceButton() && (
          <MobileSliceCtaButton
            data-autobot-element-id='CTA_SLICE_MOBILE'
            hasExpressDeal={this.props.hasExpressDeal}
            onListingItemSelect={this.props.onListingItemSelect}
            listings={this.props.listings}
            getRetailCount={this.getRetailCount()}
            brandReference={this.props.brandReference}
          />
        )}
      </section>
    )
  }
}

Listings.defaultProps = {
  brandReference: [],
  exdCarriers: [],
  initialDeviceWidth: 0,
  listingIsLoading: false,
  listingsDidMountCallbacks: [],
  listingsMetaData: {},
  priceGuidanceData: {},
  SETI: [],
  showBaggageFeeLink: true,
  showFilterChips: false,
}

Listings.propTypes = {
  activeTabId: PropTypes.number,
  children: PropTypes.node,
  // TODO: use arrayOf(Shape) later
  deeplinkModelToken: PropTypes.string,

  // PKG specific
  disableAds: PropTypes.bool,
  disableTaxesAndFeesDisclosure: PropTypes.bool,
  CTAText: PropTypes.string,
  pricingDisclosure: PropTypes.string,
  excludeSliceFiltering: PropTypes.bool,
  listings: PropTypes.array.isRequired,
  SETI: PropTypes.arrayOf(
    PropTypes.shape({
      setiTagName: PropTypes.string.isRequired,
      setiVariantName: PropTypes.string.isRequired,
    })
  ),
  showLoadingScreenServerSide: PropTypes.func,
  anySlicesFilteredFor: PropTypes.bool,

  onListingItemSelect: PropTypes.func.isRequired,
  onSliceFilter: PropTypes.func,

  listingIsLoading: PropTypes.bool,

  pclnGptDartAds: PropTypes.arrayOf(
    PropTypes.shape({
      adUnitPath: PropTypes.string.isRequired,
      gptDivId: PropTypes.string.isRequired,
      adSize: PropTypes.arrayOf(PropTypes.number).isRequired,
    })
  ),

  onExdItemSelect: PropTypes.func,
  flyGaLogic: PropTypes.shape({
    fire: PropTypes.shape({
      addSetiDimension: PropTypes.func.isRequired,
      sopqAction: PropTypes.func.isRequired,
      popularFlights: PropTypes.func.isRequired,
      sopqUrl: PropTypes.func,
      sponsoredCarrier: PropTypes.func,
      EXDListingsPositionClicked: PropTypes.func.isRequired,
      fireGenericListingsEvent: PropTypes.func.isRequired,
    }),
  }).isRequired,
  pclnExpt: PropTypes.shape({
    fireImpression: PropTypes.func.isRequired,
  }).isRequired,
  departingFrom: PropTypes.shape({
    cityCode: PropTypes.string,
    airportCode: PropTypes.string,
  }),
  returningFrom: PropTypes.shape({
    cityCode: PropTypes.string,
    airportCode: PropTypes.string,
  }),
  searchKey: PropTypes.string.isRequired,
  searchRequest: PropTypes.object,
  listingsSaleStyle: PropTypes.shape({
    bg: PropTypes.string,
    badgeText: PropTypes.string,
    copyText: PropTypes.string,
  }),
  exdCarriers: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string,
      name: PropTypes.string,
    })
  ),
  product: PropTypes.string,
  onListingsMount: PropTypes.func,
  userLoggedIn: PropTypes.bool,
  airportToCity: PropTypes.object.isRequired,
  searchReferralId: PropTypes.string,
  searchedTravelDate: PropTypes.string,
  searchedReturnDate: PropTypes.string,
  nonStopPrice: PropTypes.number,
  displayNonStopItins: PropTypes.func,
  outBoundFlight: PropTypes.bool,
  isRTSliceBySlice: PropTypes.bool,
  tripType: PropTypes.string,
  isRoundTrip: PropTypes.bool,
  isMultiDestination: PropTypes.bool,
  isSBS: PropTypes.bool,
  slices: PropTypes.array,
  brandReference: PropTypes.arrayOf(
    PropTypes.shape({
      brandId: PropTypes.string,
      name: PropTypes.string,
      tier: PropTypes.string,
      brandAttribute: PropTypes.arrayOf(
        PropTypes.shape({
          type: PropTypes.string,
          inclusion: PropTypes.string,
        })
      ),
    })
  ),
  useRenderInView: PropTypes.bool,
  alwaysRenderFirstN: PropTypes.number,
  searchRequestCabinClass: PropTypes.string,
  hasExpressDeal: PropTypes.bool,
  handleDepartureSliceClick: PropTypes.func,
  handleTabChange: PropTypes.func,
  isCachedListings: PropTypes.bool,
  isShelfEligible: PropTypes.bool,
  minimumRetailPrice: PropTypes.string,
  priceGuidanceData: PropTypes,
  cancellationText: PropTypes.func,
  cancelTextColor: PropTypes.string,
  cancelFooterIcon: PropTypes.element,
  hasEuropeFlight: PropTypes.bool,
  vipTier: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  isExpoToggleLD: PropTypes.object,
  showOriginDate: PropTypes.bool,
  departureSummaryCardStickyTop: PropTypes.string,
  clearFilters: PropTypes.func,
  filtersLists: PropTypes.array,
  numSlices: PropTypes.number,
  isReshopExperience: PropTypes.bool,
  reshopPerPersonText: PropTypes.string,
  searchSlices: PropTypes.array,
  showLoadingOverlay: PropTypes.bool,
  showBaggageFeeLink: PropTypes.bool,
  isUpsellTray: PropTypes.bool,
  isMultipleAirlinesLogoVariant: PropTypes.bool,
  fetchUpsellTrayOptions: PropTypes.func,
  gaTagUpsellTileClick: PropTypes.func,
  errorLogUpsellCallListings: PropTypes.func,
}

Listings.childContextTypes = {
  anySlicesFilteredFor: PropTypes.bool,
  CTAText: PropTypes.string,
  CTAButtonTextExd: PropTypes.string,
  excludeSliceFiltering: PropTypes.bool,
  featureConfig: PropTypes.object,
  flyGaLogic: PropTypes.object,
  isAir: PropTypes.bool,
  isPkg: PropTypes.bool,
  onExdItemSelect: PropTypes.func,
  searchKey: PropTypes.string,
  onSelect: PropTypes.func,
  onSliceFilter: PropTypes.func,
  pclnExpt: PropTypes.object,
  pricingDisclosure: PropTypes.string,
  SETI: PropTypes.object,
  isShelfItinerary: PropTypes.bool,
  alwaysRenderFirstN: PropTypes.number,
  priceBreakersProps: PropTypes.object,
  showFilterChips: PropTypes.bool,
}

export default Listings
